import type { Observable } from 'rxjs';

/** Lo único que se lee de la API de notificaciones del navegador. */
export type ApiPermisoNotificaciones = { permission: NotificationPermission } | null;

/** `Notification` en el navegador; `null` en el servidor (SSR) o sin soporte. */
export function apiNotificaciones(): ApiPermisoNotificaciones {
  return typeof Notification !== 'undefined' ? Notification : null;
}

/**
 * Sólo se pide el token FCM con el permiso YA concedido. Con 'default' `getToken()` de
 * Firebase llamaría a `Notification.requestPermission()`, y fuera de un gesto del usuario
 * el navegador bloquea o esconde ese aviso; con 'denied' no hay token posible.
 */
export function debePedirToken(api: ApiPermisoNotificaciones): boolean {
  return api?.permission === 'granted';
}

/**
 * Refresca el token FCM en silencio al arrancar (`refrescar(false)`) y en cada inicio de
 * sesión (`refrescar(true)`, para ligarlo a la cuenta nueva), sólo si el permiso ya está
 * concedido. Nunca pide permiso: eso lo hace únicamente el interruptor «En el navegador»
 * del modal de alertas (NotificacionesNavegadorService.activar), dentro del clic.
 */
export function sincronizarTokenNotificaciones({
  api = apiNotificaciones,
  login$,
  refrescar,
}: {
  api?: () => ApiPermisoNotificaciones;
  login$: Observable<unknown>;
  refrescar: (forzar: boolean) => unknown;
}): { unsubscribe(): void } {
  if (debePedirToken(api())) refrescar(false);
  return login$.subscribe(() => {
    if (debePedirToken(api())) refrescar(true);
  });
}
